<template>
  <div class="">
    <router-link
      :to="{
        name: 'dealerDashboard',
        query: {
          dealerId: data.id,
          companyId: this.$route.query.companyId
            ? this.$route.query.companyId
            : data.companyId,
        },
      }"
      style="text-decoration: none; color: rgb(75, 44, 114); width: auto"
      class="details_btn"
    >
      {{ $t("text.clickButtons.view") }}
      <i class="fa fa-eye primary-color"> </i>
    </router-link>
    <router-link
      :to="{
        name: 'our_branches',
        query: { dealerId: data.id, companyId: $route.query.companyId },
      }"
      style="text-decoration: none; color: rgb(75, 44, 114); width: auto"
      class="details_btn"
    >
      {{ $t("text.clickButtons.branches") }} {{ data.numberOfBranches }}
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {},
};
</script>
